<head>
  <script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.5.0/Chart.bundle.min.js"></script>
</head>
<div class="main-tab-title-box">
  <mat-card-title class="main-title">Lexis: English Vocabulary Profile <br>({{currentEnglishType2}})</mat-card-title>
  <div>
    <analysis-options></analysis-options>
  </div>
</div>
<div *ngIf="loaderActive" class="div_loader_pag">
  <div  id="div_loader_pag">
    <div  class="loader_pag"></div>
  </div>
  <div class="main-box-title-12">Analysis will begin after you finish typing</div>
</div>
<div *ngIf="loaderActive2  && !this.loaderActiveFirstProject" class="div_loader_pag">
  <div  id="div_loader_pag">
    <div  class="loader_pag"></div>
  </div>
  <div class="main-box-title-12">Analysing and Saving</div>
</div>
<div *ngIf="loaderActiveFirstProject" class="div_loader_pag">
  <div  id="div_loader_pag">
    <div  class="loader_pag"></div>
  </div>
  <div class="main-box-title-12">Analysing...</div>
</div>
<mat-card-content>
  <div *ngIf="short_words" class="message">
    <div class="line"></div>
    <p>Lexical scores are not accurate on short documents.</p>
  </div>
  <span class="main-box-title-14">This tool assigns each word a CEFR level, according to the English Vocabulary Profile from Cambridge University Press. You can change the English type in the Analysis Options above. <br><br>
    If you want to correct the analysis, click on the "<img src="./assets/images/project-icon.svg" class="icon-project" style="cursor: inherit;">" icon next to a word below, change the tag, then click Update.</span>
    
  <div id="button-switch-box">
    <div class="button-container left" [ngClass]="{'selected': isSelected('wl')}" (click)="selectMenuItem('wl')">
      <div style="margin-top: 8px;">
        <img style="margin-right: 8px; padding-bottom: 2px; vertical-align: middle;"
          src="./assets/images/extra_tab_icons/word-list-icon.svg">
        <span class="main-box-title-14" style="padding-top: 2px;">Word List</span>
      </div>
    </div>
    <div class="separator"></div>
    <div class="button-container right" [ngClass]="{'selected': isSelected('wc')}" (click)="selectMenuItem('wc')">
      <div style="margin-top: 8px;">
        <img style="margin-right: 8px; padding-bottom: 2px; vertical-align: middle;"
          src="./assets/images/extra_tab_icons/charts-icon.svg">
        <span class="main-box-title-14" style="padding-top: 2px;">Word Charts</span>
      </div>
    </div>
  </div>
  <!--------------------------------------------->
  <!--------------------------------------------->
  <!-----------------WORD LIST------------------->
  <!--------------------------------------------->
  <!--------------------------------------------->

  <ng-container *ngIf="selectedMenuItem === 'wl'">
    <div id="buttons-box">
      <div style="width: 70px;">

      </div>
      <span style="padding-left: 15px;">
        <button [matMenuTriggerFor]="fileMenu" class="icon-button" (click)="toggleIcon()" [disabled]="isButtonDisabled()" [ngClass]="{'disabled-button': isButtonDisabled()}">

          <span class="button-export">
            <div><img src="../assets/images/export-con.svg" class="export-con"></div><span>Lexis:
              EVP
              Export</span>
          </span>
          <mat-icon class="right-icon" [ngClass]="{'rotated-icon': isIconRotated, 'normal-icon': !isIconRotated}">expand_more</mat-icon>
        </button>
        <mat-menu #fileMenu="matMenu" (closed)="resetIcon()" xPosition="before">
          <button mat-menu-item (click)="export_detallado()">Export Statistics And Details</button>
          <button mat-menu-item (click)="export_tagger()">Export Tagged Data</button>
        </mat-menu>
      </span>

    </div>

    <!--------------------------->
    <!--------------------------->
    <!------Advanced Mode-------->
    <!--------------------------->
    <!--------------------------->
    <ng-container *ngIf="checked">
      <div class="div_scroll_box evp-table-scroll">
        <div class="evp-table-width evp-table-width-advanced">
        <div id="evp-box" class="evp-grid evp-grid-advanced evp-header-grid" style="text-align: left;">
          <div class="evp-col-eye">
            <button *ngIf="!hideEyeIconsForSafari1561" class="button-seeAll evp-see-all-button" (click)="toggleSeeAll()" [disabled]="isButtonDisabled()" [ngClass]="{'disabled-button': isButtonDisabled()}">
              <img class="see-all-icon eye-icon evp-see-all-icon" [src]="seeAllIconSrc">
              <span class="main-box-title-12 evp-see-all-label">See<br>All</span>
            </button>
          </div>
          <div class="evp-col-level evp-header-cell evp-header-cell-single">
            <div class="main-box-title-12 evp-header-line">CEFR</div>
          </div>
          <div class="evp-col-metric">
            <div class="evp-header-cell evp-header-cell-double">
              <div class="main-box-title-12 evp-header-line">Types</div>
              <div class="main-box-title-12 evp-header-line">(Unique tokens)</div>
            </div>
          </div>
          <div class="evp-col-metric">
            <div class="evp-header-cell evp-header-cell-single">
              <div class="main-box-title-12 evp-header-with-tooltip">Tokens
                <div class="tooltip-container tooltip-below-right">
                  <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
                  <span class="tooltip-text">Tokens are similar to words, but include punctuation and other elements.</span>
                </div>
              </div>
            </div>
          </div>
          <div class="evp-col-cumul">
            <div class="evp-header-cell evp-header-cell-double">
              <div class="main-box-title-12 evp-header-line">Cumul %</div>
              <div class="main-box-title-12 evp-header-with-tooltip">Types
                <div class="tooltip-container tooltip-below-right">
                  <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
                  <span class="tooltip-text">This shows the cumulative percentage of types (unique tokens) in each category, which is a running total of percentages, as you descend down the table. </span>
                </div>
              </div>
            </div>
          </div>
          <div class="evp-col-cumul">
            <div class="evp-header-cell evp-header-cell-double">
              <div class="main-box-title-12 evp-header-line">Cumul %</div>
              <div class="main-box-title-12 evp-header-with-tooltip">Tokens
                <div class="tooltip-container tooltip-below-right">
                  <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
                  <span class="tooltip-text">This shows the cumulative percentage of tokens in each category, which is a running total of percentages, as you descend down the table.</span>
                </div>
              </div>
            </div>
          </div>
          <div class="evp-col-expand"></div>
        </div>
        <ng-container *ngFor="let data of getObjectKeys(encabezados)">
          <div class="vertical-box evp-row-shell">
            <!-- Mostrar detalles de la palabra seleccionada -->
            <div *ngIf="selectedWord[data]" id="div-category">
               <div style="display: flex; justify-content: space-between; align-items: center;">
              <div style="display: flex;">
                <button class="reset-button" (click)="resetCategoryView(data)">
                  <img src="./assets/images/black_icons/back-Icon.svg">
                </button>
                <div class="main-box-title-16" style="padding-top: 1px;">Change Tag</div>
              </div>
              <button class="main-box-title-14 update-button" (click)="updateCategory(data)">Update</button>
            </div>
              <ng-container *ngFor="let datos of data_pof2[data.toUpperCase()][selectedWord[data]]; index as i">
                <div style="margin-bottom: 20px; margin-top: 10px;">
                  <div class="horizontal-box" style="border: none; margin-bottom: 0px;">
                      <div class="main-box-title-14" style="margin-right: 20px; margin-left: 10px;"><img class="eye-icon"
                        [src]="palabraSeleccionada[data.toUpperCase() + '-' + selectedWord[data] + '-' + i] 
                              ? '../../assets/images/yellow_icons/eye-on-icon.svg' 
                              : '../../assets/images/eye-icon.svg'"
                        (click)="verPalabra(selectedWord[data], data, i,true)" *ngIf="!hideEyeIconsForSafari1561">
                      <strong>{{selectedWord[data]}}</strong></div>
                      <div class="main-box-title-12"> <strong>{{transform(i+1)}}</strong> word: ({{data_pof2[data.toUpperCase()][selectedWord[data]][i]}})</div>
                  </div>
                  <!-- Nuevo div para mostrar el arreglo de la Palabra Seleccionada -->
                  
                  <div *ngIf="respuestaWords" class="main-box-title-12">
                    <table class="custom-table">
                        <thead>
                            <tr>
                                <th class="custom-header">Selection</th>
                                <th class="custom-header">CEFR</th>
                                <th class="custom-header" style="text-align: center;">Part of speech</th>
                                <th class="custom-header" style="text-align: left;">Description</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of respuestaWords">
                                <input type="radio" 
                                  name="palabra-{{i}}" 
                                  [value]="item.id" 
                                  (change)="onSelectionRadioChange(item, i, data.toUpperCase()); verPalabra(selectedWord[data], data, i,false)" 
                                  [checked]="isWordSelected(data, i, item)"
                                />
                                <td class="custom-cell">{{ item.nivel }}</td>
                                <td class="custom-cell">{{ item.tipo }}</td>
                                <td class="custom-cell description-cell">{{ item.descripcion }}</td>
                            </tr>
                        </tbody>
                    </table>
                  </div>
                </div>
              </ng-container>
            </div>
          
            <!-- Mostrar lista completa de palabras si no hay ninguna seleccionada -->
            <div *ngIf="!selectedWord[data]">
              <div class="horizontal-box evp-grid evp-grid-advanced evp-row-grid" style="border: none; margin-bottom: 0px; cursor: pointer;"
                [ngClass]="{'expanded': isExpanded[encabezados[data].Name]}" (click)="toggleExpand(encabezados[data].Name)">
                <div id="div_eye_icon" class="evp-col-eye">
                  <img *ngIf="!hideEyeIconsForSafari1561" class="eye-icon"  [src]="isEyeOn[data?.toUpperCase()] 
                ? '../../assets/images/yellow_icons/eye-on-icon.svg' 
                : '../../assets/images/eye-icon.svg'"
                    (click)="toggleEyeIcon(data); $event.stopPropagation()">
                </div>

                <ng-container *ngIf="isKnownWordsCategory(encabezados[data].Name); else StandardOrUnlistedAdvancedBox">
                  <div class="evp-col-level">
                    <div class="evp-knownwords-badge">
                      <div class="evp-knownwords-label">{{getKnownWordsLabel(encabezados[data].Name)}}</div>
                    </div>
                  </div>
                </ng-container>
                <ng-template #StandardOrUnlistedAdvancedBox>
                  <ng-container *ngIf="encabezados[data].Name.toUpperCase() != 'UNLISTED'; else UnlistedAdvancedBox">
                    <div id="div_box_score" class="evp-col-level">
                      <div id="box-score" [ngStyle]="{'background-color': traducirColor(encabezados[data].Name)}">
                        <div style="text-align: center; align-items: center; width: 30px;">{{encabezados[data].Name | titlecase}} 
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </ng-template>
                <ng-template #UnlistedAdvancedBox>
                  <div class="evp-col-level">
                    <div class="evp-unlisted-wrapper">
                      <div class="evp-unlisted-badge">
                        <div class="evp-unlisted-label">{{encabezados[data].Name| titlecase}}</div>
                      </div>
                      <div class="tooltip-container evp-unlisted-tooltip" (click)="$event.stopPropagation()">
                        <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
                        <span class="tooltip-text">Words in your text that are not found in the EVP word list</span>
                      </div>
                    </div>
                  </div>
                </ng-template>

                <div class="main-box-title-14 evp-col-metric">{{encabezados[data].unique_words ?
                  encabezados[data].unique_words : "--"}} ({{encabezados[data].cumul_unique ? encabezados[data].cumul_unique : "--"}})</div>
                <div class="main-box-title-14 evp-col-metric" id="div_words">{{encabezados[data].words ?
                  encabezados[data].words : "--"}} ({{encabezados[data].cumul_words ? encabezados[data].cumul_words : "--"}})</div>
                <div class="main-box-title-14 evp-col-cumul" id="div_c_u_words">{{encabezados[data].suma_unique_words ?
                  encabezados[data].suma_unique_words : "--"}}</div>
                <div class="main-box-title-14 evp-col-cumul" id="div_c_words">{{encabezados[data].suma_cumul_words ?
                  encabezados[data].suma_cumul_words : "--"}}</div>
                <mat-icon class="expand-icon evp-col-expand" >expand_more</mat-icon>
              </div>
              <div
              class="words-content"
                *ngIf="isExpanded[encabezados[data].Name] && evpDataReady">
                <ng-container *ngFor="let item of getObjectKeys(data_pof?.[data?.toUpperCase()] ?? tempEmpty)">
                  <div class="item-listado-errores">
                    <span (mouseenter)="ponerOjo($event, data, item)" (mouseleave)="quitarOjo($event, data, item)"
                      style="display:flex; padding: 4px;">
                      <ng-container *ngIf="isScreenLarge; else mobileLayout">
                        <img src="./assets/images/eye-icon.svg" *ngIf="!hideEyeIconsForSafari1561 && !palabraresaltada?.[data?.toUpperCase()]?.[item]"
                          (click)="toggleEyeIconPalabra(data, item)" class="icon-eye" style="margin-right: 5px;">
                        <img src="./assets/images/yellow_icons/eye-on-icon.svg" *ngIf="!hideEyeIconsForSafari1561 && palabraresaltada?.[data?.toUpperCase()]?.[item]"
                          (click)="toggleEyeIconPalabra(data, item)" class="icon-eye" style="margin-right: 5px;">
                        <img src="./assets/images/project-icon.svg" style="margin-right: 5px;"
                          (click)="selectWord(data, item)" class="icon-project">
                        <div>
                          {{item}} / {{data_pof[data.toUpperCase()][item]}}
                        </div>
                      </ng-container>

                      <ng-template #mobileLayout>
                        <img src="./assets/images/eye-icon.svg" *ngIf="!hideEyeIconsForSafari1561 && !palabraresaltada?.[data]?.[item]"
                          (touchstart)="toggleEyeIconPalabra(data, item)" class="icon-eye" style="margin-right: 6px;">
                        <img src="./assets/images/yellow_icons/eye-on-icon.svg" *ngIf="!hideEyeIconsForSafari1561 && palabraresaltada?.[data]?.[item]"
                          (touchstart)="toggleEyeIconPalabra(data, item)" class="icon-eye" style="margin-right: 6px;">
                        <img src="./assets/images/project-icon.svg" style="margin-right: 6px;"
                          (touchstart)="selectWord(data, item)" class="icon-project">
                        <div>
                          {{item}} / {{data_pof[data.toUpperCase()][item]}}
                        </div>
                      </ng-template>


                    </span>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </ng-container>
        </div>
      </div>
    </ng-container>

    <!--------------------------->
    <!--------------------------->
    <!--------Simple Mode-------->
    <!--------------------------->
    <!--------------------------->
    <ng-container *ngIf="!checked">
      <div class="div_scroll_box evp-table-scroll">
      <div class="evp-table-width evp-table-width-simple">
      <div class="content-show-all">
        <button mat-button style="color:#EEA21A;font-size: 14px;" (click)="toggleExpandAll()" [disabled]="isButtonDisabled()" [ngClass]="{'disabled-button': isButtonDisabled()}">
          {{ showAll ? 'Show All' : 'Hide All' }}
        </button>
      </div>

      <div id="evp-box" class="evp-grid evp-grid-simple evp-header-grid evp-simple-header" style="text-align: left; justify-content: none; margin-bottom: 0px;">
        <div class="evp-col-eye">
          <button *ngIf="!hideEyeIconsForSafari1561" class="button-seeAll-Simple evp-see-all-button" (click)="toggleSeeAll()" [disabled]="isButtonDisabled()" [ngClass]="{'disabled-button': isButtonDisabled()}">
            <img class="see-all-icon eye-icon evp-see-all-icon" [src]="seeAllIconSrc">
            <span class="main-box-title-12 evp-see-all-label">See<br>All</span>
          </button>
        </div>
        <div class="evp-col-level evp-header-cell evp-header-cell-single">
          <div class="main-box-title-12 evp-header-line">CEFR</div>
        </div>
        <div class="evp-col-metric">
          <div class="evp-header-cell evp-header-cell-double">
            <div class="main-box-title-12 evp-header-line">Types</div>
            <div class="main-box-title-12 evp-header-line">(Unique tokens)</div>
          </div>
        </div>
        <div class="evp-col-metric">
          <div class="evp-header-cell evp-header-cell-single">
            <div class="main-box-title-12 evp-header-with-tooltip">Tokens
              <div class="tooltip-container tooltip-below-right">
                <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
                <span class="tooltip-text">Tokens are similar to words, but include punctuation and other elements.</span>
              </div>
            </div>
          </div>
        </div>
        <div class="evp-col-expand"></div>
      </div>
      <ng-container *ngFor="let data of getObjectKeys(encabezados)">
        <div class="vertical-box evp-row-shell">
          <!-- Mostrar detalles de la palabra seleccionada -->
          <div *ngIf="selectedWord[data]" id="div-category">
            <div style="display: flex; justify-content: space-between; align-items: center;">
              <div style="display: flex;">
                <button class="reset-button" (click)="resetCategoryView(data)">
                  <img src="./assets/images/black_icons/back-Icon.svg">
                </button>
                <div class="main-box-title-16" style="padding-top: 1px;">Change Tag</div>
              </div>
              <button class="main-box-title-14 update-button" (click)="updateCategory(data)">Update</button>
            </div>
            <ng-container *ngFor="let datos of data_pof2[data.toUpperCase()][selectedWord[data]]; index as i">
              <div class="horizontal-box" style="border: none; margin-bottom: 0px;">
                  <div class="main-box-title-14" style="margin-right: 20px; margin-left: 10px;"><strong>{{selectedWord[data]}}</strong></div>
                  <div class="main-box-title-12"> <strong>{{transform(i+1)}}</strong> word: ({{data_pof2[data.toUpperCase()][selectedWord[data]][i]}})</div>
              </div>
              <!-- Nuevo div para mostrar el arreglo de la Palabra Seleccionada -->
              
              <div *ngIf="respuestaWords" class="main-box-title-12">
                <table class="custom-table">
                    <thead>
                        <tr>
                            <th class="custom-header">Selection</th>
                            <th class="custom-header">CEFR</th>
                            <th class="custom-header" style="text-align: center;">Part of speech</th>
                            <th class="custom-header" style="text-align: left;">Description</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of respuestaWords">
                            <input type="radio" 
                              name="palabra-{{i}}" 
                              [value]="item.id" 
                              (change)="onSelectionRadioChange(item, i, data.toUpperCase())" 
                              [checked]="isWordSelected(data, i, item)"
                            />
                            <td class="custom-cell">{{ item.nivel }}</td>
                            <td class="custom-cell">{{ item.tipo }}</td>
                            <td class="custom-cell description-cell">{{ item.descripcion }}</td>
                        </tr>
                    </tbody>
                </table>
              </div>
            </ng-container>
          </div>

          <!-- Mostrar lista completa de palabras si no hay ninguna seleccionada -->
          <div *ngIf="!selectedWord[data]">
            <div class="horizontal-box evp-grid evp-grid-simple evp-row-grid" style="border: none; margin-bottom: 0px;"
              [ngClass]="{'expanded': isExpanded[encabezados[data].Name]}" (click)="toggleExpand(encabezados[data].Name)">
              <div id="div_eye_icon" class="evp-col-eye">
                <img class="eye-icon" [src]="imgSrc[data] || '../../assets/images/eye-icon.svg'"
                  (click)="toggleEyeIcon(data); $event.stopPropagation()" *ngIf="!hideEyeIconsForSafari1561">
              </div>

              <ng-container *ngIf="isKnownWordsCategory(encabezados[data].Name); else StandardOrUnlistedSimpleBox">
                <div class="evp-col-level">
                  <div class="evp-knownwords-badge">
                    <div class="evp-knownwords-label">{{getKnownWordsLabel(encabezados[data].Name)}}</div>
                  </div>
                </div>
              </ng-container>
              <ng-template #StandardOrUnlistedSimpleBox>
                <ng-container *ngIf="encabezados[data].Name.toUpperCase() != 'UNLISTED'; else UnlistedSimpleBox">
                  <div id="div_box_score" class="evp-col-level">
                    <div id="box-score" [ngStyle]="{'background-color': traducirColor(encabezados[data].Name)}">
                      <div style="text-align: center; align-items: center; width: 30px;">{{encabezados[data].Name | titlecase}} 
                      </div>
                    </div>
                  </div>
                </ng-container>
              </ng-template>
              <ng-template #UnlistedSimpleBox>
                <div class="evp-col-level">
                  <div class="evp-unlisted-wrapper">
                    <div class="evp-unlisted-badge">
                      <div class="evp-unlisted-label">{{encabezados[data].Name| titlecase}}</div>
                    </div>
                    <div class="tooltip-container evp-unlisted-tooltip" (click)="$event.stopPropagation()">
                      <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
                      <span class="tooltip-text">Words in your text that are not found in the EVP word list</span>
                    </div>
                  </div>
                </div>
              </ng-template>

              <div class="main-box-title-14 evp-col-metric">{{encabezados[data].unique_words ?
                encabezados[data].unique_words : "--"}} ({{encabezados[data].cumul_unique ? encabezados[data].cumul_unique : "--"}}%)</div>
              <div class="main-box-title-14 evp-col-metric" id="div_words">{{encabezados[data].words ? encabezados[data].words : "--"}} ({{encabezados[data].cumul_words ? encabezados[data].cumul_words : "--"}}%)</div>
              <mat-icon class="expand-icon evp-col-expand">expand_more</mat-icon>
            </div>
            <div
              class="words-content"
                *ngIf="isExpanded[encabezados[data].Name] && evpDataReady">
                <ng-container *ngFor="let item of getObjectKeys(data_pof[data.toUpperCase()])">
                  <div class="item-listado-errores">
                    <span (mouseenter)="ponerOjo($event, data, item)" (mouseleave)="quitarOjo($event, data, item)"
                      style="display:flex; padding: 4px;">
                      <ng-container *ngIf="isScreenLarge; else mobileLayout">
                        <img src="./assets/images/eye-icon.svg" *ngIf="!hideEyeIconsForSafari1561 && !palabraresaltada[data][item]"
                          (click)="toggleEyeIconPalabra(data, item)" class="icon-eye" style="margin-right: 5px;">
                        <img src="./assets/images/yellow_icons/eye-on-icon.svg" *ngIf="!hideEyeIconsForSafari1561 && palabraresaltada[data][item]"
                          (click)="toggleEyeIconPalabra(data, item)" class="icon-eye" style="margin-right: 5px;">
                        <!-- <img src="./assets/images/project-icon.svg" style="margin-right: 5px;"
                          (click)="selectWord(data, item)" class="icon-project"> -->
                        <div>
                          {{item}} / {{data_pof[data.toUpperCase()][item]}}
                        </div>
                      </ng-container>

                      <ng-template #mobileLayout>
                        <img src="./assets/images/eye-icon.svg" *ngIf="!hideEyeIconsForSafari1561 && !palabraresaltada[data][item]"
                          (touchstart)="toggleEyeIconPalabra(data, item)" class="icon-eye" style="margin-right: 6px;">
                        <img src="./assets/images/yellow_icons/eye-on-icon.svg" *ngIf="!hideEyeIconsForSafari1561 && palabraresaltada[data][item]"
                          (touchstart)="toggleEyeIconPalabra(data, item)" class="icon-eye" style="margin-right: 6px;">
                        <!-- <img src="./assets/images/project-icon.svg" style="margin-right: 6px;"
                          (touchstart)="selectWord(data, item)" class="icon-project"> -->
                        <div>
                          {{item}} / {{data_pof[data.toUpperCase()][item]}}
                        </div>
                      </ng-template>


                    </span>
                  </div>
                </ng-container>
              </div>
          </div>
        </div>
      </ng-container>
      </div>
      
      
      <!-- <div class="vertical-box">
        <div class="horizontal-box" style="border: none; margin-bottom: 0px;" [ngClass]="{'expanded': isExpanded['A1']}">
          <div id="i_div_eye_icon">
            <img class="eye-icon" (click)="toggleEyeIcon($event)" src="../../assets/images/eye-icon.svg">
          </div>
          <div id="i_div_box_score">
            <div id="i_box-score" style="background-color: #F66B2D;">
              <div style="text-align: center; align-items: center; width: 30px;">A1</div>
            </div>
          </div>
          <div style="width: 30px; height: 20px; "></div>
          <div class="main-box-title-14" id="i_div_u_words">{{unique_words_A1 ? unique_words_A1 : "--"}} (33.33%)</div>
          <div class="main-box-title-14" id="i_div_words">{{words_A1 ? words_A1 : "--"}} (50.47%)</div>
          <div style="width: 70px; height: 20px; "></div>
          <mat-icon class="expand-icon" (click)="toggleExpand('A1')">expand_more</mat-icon>
        </div>
        <div class="horizontal-box" style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;" *ngIf="isExpanded['A1']">
          <div class="vertical-box" *ngFor="let chunk of dividedData['A1']" style="border: none; margin-bottom: 0px; padding: 0px;">
            <div *ngFor="let item of chunk" >
              <p class="text-item">{{item.word}} ({{item.count}})</p>
              
            </div>
          </div>
        </div>
      </div> -->

    </div>
      
    </ng-container>

    <div class="evp-phrase-match-setting">
      <mat-checkbox
        color="accent"
        [checked]="matchPrhases"
        (change)="onMatchPhrasesChange($event)"
        disableRipple
        [disabled]="isButtonDisabled() || isUpdatingMatchPhrases"
        [ngClass]="{'disabled-button': isButtonDisabled() || isUpdatingMatchPhrases}">
        Look for phrase matches
      </mat-checkbox>
      <p class="evp-phrase-match-note">
        Note: changing this will lose any manual changes to tagging.
      </p>
    </div>

   
  </ng-container>

  <!--------------------------------------------->
  <!--------------------------------------------->
  <!----------------WORD CHARTS------------------>
  <!--------------------------------------------->
  <!--------------------------------------------->

  <ng-container *ngIf="selectedMenuItem === 'wc'">

    <div class="chart-container">
      <div
        style="width: auto;align-items: center; text-align: center; font-size: 14px; font-weight: bold; font-family: 'Inter';color: #2A3654; margin-bottom: 20px;">
        Types (Unique tokens)</div>
        <div class="scroll_chart">
          <div class="size_chart">
      <canvas style="width: 100%; height: 380px; margin-left: 10%;margin-right: 10%; padding-bottom: 10px;" baseChart
        [data]="barChartData" [options]="barChartOptions" [type]="barChartType ">
      </canvas>
    </div>
    </div>
    </div>



  </ng-container>

  <ng-container *ngIf="!checked">
    <div class="text-box-bottom-simple-mode">
      <div class="line-box-bottom-simple-mode">
        <div class="bottom-text-line-simple-mode"></div>
      </div>
      <span class="main-box-title-14">To see full statistics, switch to “Advanced Mode”.</span>
    </div>
  </ng-container>

</mat-card-content>

<div #bottom></div>
